import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  Box,
  Typography,
  Paper,
  Button,
} from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';

/**
 * Cancel page displayed when user cancels Stripe checkout.
 */
const SubscriptionCancel = () => {
  const navigate = useNavigate();

  useEffect(() => {
    toast.info('Subscription cancelled. You can try again anytime.');
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '70vh',
        padding: 2,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          padding: 4,
          textAlign: 'center',
          maxWidth: 500,
          width: '100%',
        }}
      >
        <CancelIcon 
          sx={{ fontSize: 80, color: 'warning.main', mb: 2 }} 
        />
        <Typography variant="h4" gutterBottom color="warning.main">
          Subscription Cancelled
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          No worries! You can return to subscribe whenever you're ready.
        </Typography>
        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => navigate('/subscriptions')}
          >
            Back to Subscriptions
          </Button>
          <Button
            variant="outlined"
            onClick={() => navigate('/dashboard')}
          >
            Go to Dashboard
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default SubscriptionCancel;
